import { TaskStatus } from '@varos/research-sdk-api';
import { ButtonProps } from '@chakra-ui/react';
import { ReportingControllerBaseConfig } from '../../../base';
import { TaskBlockController } from './taskBlockInterface';
import { TaskBlockViewProps } from './taskBlockProps';
import { createBlockItemController } from '../../block';

export function createTaskBlockController(
    config: ReportingControllerBaseConfig
): TaskBlockController {
    const blockController = createBlockItemController();
    const colorSchemes: Record<TaskStatus, ButtonProps['colorScheme']> = {
        pending: 'blue',
        in_progress: 'blue',
        completed: 'green',
        failed: 'red',
        canceled: 'gray',
    };
    const statuses: Record<TaskStatus, string> = {
        pending: 'Pending',
        in_progress: 'In Progress',
        completed: 'Completed',
        failed: 'Failed',
        canceled: 'Canceled',
    };
    return {
        useProps(context, item, props): TaskBlockViewProps {
            const block = blockController.useProps(context, item, props.item);
            const isLoading = item.task.status === 'in_progress';
            const colorScheme = colorSchemes[item.task.status] ?? null;

            const completedSteps = item.statuses.filter(
                (status) => status.kind === 'completed'
            ).length;
            const totalSteps = item.statuses.length;
            const progress = Math.round((completedSteps / totalSteps) * 100);

            const progressSteps = item.statuses.find(
                (status) => status.kind === 'in_progress'
            );

            return {
                label: item.task.display_name,
                description: item.task.description,
                icon: null,
                // icon: item.task.icon
                //     ? {
                //           kind: 'emoji',
                //           text: item.task.icon,
                //       }
                //     : null,
                status: {
                    label: statuses[item.task.status],
                    colorScheme,
                    isLoading,
                },
                progress: {
                    // Add some minimum width
                    value: Math.max(10, progress),
                    isAnimated: isLoading,
                    min: 0,
                    max: 100,
                    colorScheme: colorScheme ?? undefined,
                },
                note: progressSteps?.description ?? null,
                block,
            };
        },
    };
}
